(() => {
  const addRel = () => {
    document
      .querySelectorAll('a[target="_blank"]:not([rel~="noopener"])')
      .forEach((a) => {
        const existing = (a.getAttribute('rel') || '').trim();
        const tokens = existing ? existing.split(/\s+/) : [];
        if (!tokens.includes('noopener')) tokens.push('noopener');
        if (!tokens.includes('noreferrer')) tokens.push('noreferrer');
        a.setAttribute('rel', tokens.join(' '));
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addRel, { once: true });
  } else {
    addRel();
  }
})();
